<template>
	<fragment>
		<class-header
			:subname="lecture.category"
			:name="lecture.lecName"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
			v-bind:sysmenuActive="false"
			:icon="lecture.lecIcon?lecture.lecIcon.atchFileId:''"
		></class-header>

		<section ref="container" class="container">
			<common-side-menu :menus="side_menus" :btnList="side_buttons" @sidemenuSelected="curriculumSelected"></common-side-menu>
			<!-- //end .side-nav -->
			<div class="container-fiuld clearfix">
				<div class="title-box m-b-30 b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">시험 관리</div>
					<!--
					<div class="btn-group pull-right p-10 p-r-0">
						<div class="select pull-left m-r-5">
							<a class="btn round pull-left" href="#">
								<img class="v-mid m-r-5" src="images/x.png" alt=""> 액셀 다운로드
							</a>
						</div>
					</div>
					-->
				</div>
				<div class="new-survey" if="!list || list.length==0">
					<img src="images/survey.png" alt=""><br>
					편집 할 시험을 선택하거나 새 시험을 만들 수 있습니다.<br>
					<a @click="createExam">새 시험 만들기</a>
				</div>

				<div class="white-box m-t-10 clearfix" v-for="(exam,idx) in list" :item="exam" :index="idx" :key="'exam-list-'+curriculumId+'-'+idx+'-'+hash(exam)">
					<div class="input-group full-width">
						<span class="input-group-addon text-left">
							<p class="f-18 m-b-0 text-bold text-blue">시험 {{idx+1}} : {{exam.examName}} ({{exam.examTime}}분 / 총 {{exam.examItemMappingList.length}}문항)</p>
							<p class="f-14 m-b-0">응시기간 : {{exam.examStart | parseRegDate}} ~ {{exam.examEnd | parseRegDate}}</p>
						</span>
						<span class="input-group-addon v-mid w400">
							<button class="btn round" @click="$router.push('/classroom/'+$route.params.lecId+'/exam/'+exam.examId+'/modify')">시험문항 편집</button>&nbsp;
							<!--
							<button class="btn round">답안 검토</button>
							-->
						</span>
						<span class="input-group-addon v-mid w60">
							<a class="del" @click="deleteExam(exam)">삭제</a>
						</span>
					</div>
				</div>
			</div>
		</section>

		<modal-confirm :config="modals.ModalConfirm" @yes="modals.ModalConfirm.show=false" @no="modals.ModalConfirm.show=false" :key="hash(modals.ModalConfirm)"></modal-confirm>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;" :key="hash(modals.ModalAlert)"></modal-alert>

		<common-footer></common-footer>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import fnGetLec from '../mixins/fnGetLec.js'
import ClassHeader from '../components/ClassHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import CommonSideMenu from '../components/CommonSideMenu.vue'
import ModalConfirm from '../modals/ModalConfirm.vue'
import ModalAlert from '../modals/ModalAlert.vue'
import axios from 'axios'
import server from '../statics/server.js'
import moment from 'moment'

export default {
	// 컴포넌트 명
	name: 'ViewClassroomExamList',
	mixins: [fnAdjustHeight, fnGetLec],
	// 이 컴포넌트에서 사용할 자식컴포넌트 목록
	components: {
		ClassHeader,
		CommonFooter,
		CommonSideMenu,
		ModalConfirm,
		ModalAlert
	},

	mounted: async function() {
		const { lecId } = this.$route.params;
		this.lecture = await this.getLecInfo(lecId);
		if(this.lecture.classroomOpt.indexOf("출결")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='출결')), 1 );
		if(this.lecture.classroomOpt.indexOf("과제")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=="과제")), 1 );
		if(this.lecture.classroomOpt.indexOf("설문")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='설문')), 1 );
		if(this.lecture.classroomOpt.indexOf("시험")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='시험')), 1 );
		//if(this.lecture.classroomOpt.indexOf("동영상 등록")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='강의 목차')), 1 );
		this.side_menus = await this.getExamSideMenus(lecId);
		if(this.side_menus.length) {
			this.side_menus[0].selected = true;
			this.curriculumId = this.side_menus[0].curriculumId;
			this.refresh();
		}
	},

	// 이 컴포넌트에서 내부적으로 사용할 데이터
	data: function() {
		const { lecId } = this.$route.params;

		return {
			lecture: {},
			menus : [
				{name:'강의 목차',link:"/classroom/"+this.$route.params.lecId+"/curriculum",selected:false},
				{name:'수강관리',link:"/classroom/"+this.$route.params.lecId+"/apply",selected:false},
				{name:'출결',link:"/classroom/"+this.$route.params.lecId+"/attendance",selected:false},
				{name:'시험',link:"/classroom/"+this.$route.params.lecId+"/exam",selected:true},
				{name:'과제',link:"/classroom/"+this.$route.params.lecId+"/assignment",selected:false},
				{name:'설문',link:"/classroom/"+this.$route.params.lecId+"/survey",selected:false},
				{name:'게시판',link:"/classroom/"+this.$route.params.lecId+"/board",selected:false},
			],
			side_menus: [],
			side_buttons : [{name: '새 시험 만들기', fn: () => {
					if(!this.curriculumId) {
						this.modals.ModalAlert.msg = "강의 목차를 먼저 만들고 선택해야 시험지를 만들 수 있습니다.";
						this.modals.ModalAlert.show = true;
						return;
					}
					this.$router.push(`/classroom/${lecId}/exam/register/`+this.curriculumId);
				}
			}],
			buttons : [
				{name:'새 시험 만들기', fn:()=>{
					if(!this.curriculumId) {
						this.modals.ModalAlert.msg = "강의 목차를 먼저 만들고 선택해야 시험지를 만들 수 있습니다.";
						this.modals.ModalAlert.show = true;
						return;
					}
					this.$router.push('/classroom/'+this.$route.params.lecId+'/exam/register/'+this.curriculumId)
				}}
			],
			modals: {
				ModalConfirm: ModalConfirm.default(),
				ModalAlert: ModalAlert.default()
			},
			curriculumId: this.$route.params.curriculumId,
			list: []
		}
	},



	// 이 컴포넌트에서 내부적으로 사용할 메써드
	methods: {
		// 시험지 만들기
		createExam: function() {
			if(!this.curriculumId) {
				this.modals.ModalAlert.msg = "강의 목차를 먼저 만들고 선택해야 시험지를 만들 수 있습니다.";
				this.modals.ModalAlert.show = true;
				return;
			}
			this.$router.push('/classroom/'+this.$route.params.lecId+'/exam/register/'+this.curriculumId)
		},
		// 시험 목록을 불러온다.
		refresh: function() {
			// 커리큘럼이 정해지지 않은 상태에서는 시험 목록을 불러올 수 없음
			if(!this.curriculumId) return;
			axios.post(server.addr()+server.api.CURRICULUM+"/"+this.curriculumId, {}).then( (response) => {
				this.list = response.data.return.curriculumExamMappingList;
			});
		},
		// 왼쪽 커리큘럼 리스트에서 커리큘럼 선택시, 왼쪽메뉴의 선택상태를 설정하고 리프래시
		curriculumSelected: function(curriculum) {
			this.side_menus.forEach(m => {if(m.curriculumId==curriculum.curriculumId) m.selected=true; else m.selected=false; });
			this.curriculumId = curriculum.curriculumId;
			this.refresh();
		},
		deleteExam: function(exam) {
			this.modals.ModalConfirm.msg = "시험지를 정말 삭제하시겠습니까?";
			this.modals.ModalConfirm.btnYes.name = "삭제";
			this.modals.ModalConfirm.btnYes.fn = () => {
				//axios.delete(server.addr()+server.api.CURRICULUM_EXAM_MAPPING, [{curriculumId:this.curriculumId, examId:exam.examId}]).then( () => {
				axios.delete(server.addr()+server.api.CURRICULUM_EXAM_MAPPING, {data:[{curriculumId:this.curriculumId, examId:exam.examId}]}).then( () => {
					this.refresh();
					this.modals.ModalConfirm.show = false;
				})
			}
			this.modals.ModalConfirm.show = true;
		}
	},

	filters: {
		parseRegDate(date){
			return moment(date).format('YYYY-MM-DD')
		},
	}
}
</script>
